'use client';

import posthog from 'posthog-js';
import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { acceptedCookiePolicyAtom } from '~/atoms';
import { CookieTypeEnum } from '~/types-and-enums/cookieTypes';
import { isProductionEnv } from '~/utils/envConfig';

const PostHogProvider = () => {
  const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const apiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;
  const acceptedCookiePolicy = useAtomValue(acceptedCookiePolicyAtom);
  const hasAnalyticsConsent = acceptedCookiePolicy.includes(CookieTypeEnum.Analytics);

  useEffect(() => {
    if (!isProductionEnv()) return;
    if (!apiKey || !apiHost || !hasAnalyticsConsent) return;
    if (posthog.__loaded) return;

    posthog.init(apiKey, {
      api_host: apiHost,
      before_send: (event) => {
        if (!event) return null;
        const EXCLUDED = ['$web_vitals', '$identify', '$opt_in', '$set'];
        return EXCLUDED.includes(event.event) ? null : event;
      },
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      advanced_disable_flags: true,
      session_recording: { maskAllInputs: true },
      enable_heatmaps: false,
      capture_heatmaps: false,
      disable_surveys: true,
      disable_web_experiments: true,
      persistence: 'localStorage',
    });
  }, [apiKey, apiHost, hasAnalyticsConsent]);

  useEffect(() => {
    if (!posthog.__loaded) return;
    if (!hasAnalyticsConsent) {
      posthog.opt_out_capturing();
    } else {
      posthog.opt_in_capturing();
    }
  }, [hasAnalyticsConsent]);

  return null;
};

export default PostHogProvider;
